<div class="auth-wrapper">
  <div *ngIf="loader" id="loader"></div>

  <div class="hero card-glass mb-3">
    <p class="eyebrow">Spay · Connexion</p>
    <h1>Connectez-vous</h1>
    <p class="lead">Accédez à votre espace en toute sécurité.</p>
    <p *ngIf="problemAcure" class="alert-text danger mt-2">Données de connexion incorrectes.</p>
  </div>

  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card card-glass p-3">
        <div class="text-center mb-3">
          <img src="assets/icons/icon-96x96.png" width="120" height="120" alt="Spay logo">
          <h5 class="mt-2">Connexion</h5>
        </div>
        <form [formGroup]="userLogin" #f="ngForm" (ngSubmit)="onlogin(f.value)" class="row g-3">
          <div class="col-12">
            <label class="form-label">Email</label>
            <input formControlName="username" name="username" type="text" class="form-control" placeholder="Votre email" required autofocus>
          </div>
          <div class="col-12">
            <label class="form-label">Mot de passe</label>
            <input formControlName="password" name="password" [type]="show ? 'text' : 'password'" class="form-control" placeholder="Mot de passe" required>
          </div>
          <div class="col-12 d-flex align-items-center gap-2">
            <input type="checkbox" class="form-check-input mt-0" (click)="showPassword()" id="showPassLogin">
            <label class="form-check-label" for="showPassLogin">Afficher le mot de passe</label>
          </div>
          <div class="col-12 d-grid">
            <button type="submit" class="btn btn-primary btn-pill" [disabled]="!userLogin.valid">Continuer</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal-backdrop fade show" *ngIf="deviceChallenge"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="deviceChallenge" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content challenge-modal">
        <div class="modal-header border-0 pb-0">
          <div>
            <p class="eyebrow mb-1">Nouvel appareil</p>
            <h5 class="modal-title mb-0">Validation requise</h5>
          </div>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="closeDeviceChallenge()"></button>
        </div>
        <div class="modal-body pt-2">
          <p class="small mb-2">
            Un code OTP a été envoyé par
            <strong>{{ deviceChallenge.deliveryChannel || 'OTP' }}</strong>
            vers <strong>{{ deviceChallenge.maskedTarget || 'votre contact' }}</strong>.
          </p>
          <p class="small text-muted mb-3" *ngIf="challengeExpiryLabel">
            Expire le {{ challengeExpiryLabel }}.
          </p>

          <label class="form-label">Code OTP (6 chiffres)</label>
          <input [formControl]="deviceOtp" type="text" inputmode="numeric" maxlength="6" class="form-control"
            placeholder="Ex: 123456">
          <small class="text-danger" *ngIf="deviceOtp.invalid && deviceOtp.touched">
            Entrez un code valide de 6 chiffres.
          </small>
          <small class="text-danger d-block mt-2" *ngIf="deviceChallengeError">{{ deviceChallengeError }}</small>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-outline-light" (click)="closeDeviceChallenge()" [disabled]="validatingDevice">
            Annuler
          </button>
          <button type="button" class="btn btn-primary btn-pill" (click)="submitDeviceValidation()" [disabled]="validatingDevice">
            {{ validatingDevice ? 'Validation...' : 'Valider l’appareil' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
